import { useEffect, useState } from 'react';

export const useCountdownTimer = (targetDate: Date, onComplete?: VoidFunction) => {
  const [timeLeft, setTimeLeft] = useState(targetDate.getTime() - Date.now());

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;

    const updateTimer = () => {
      const diff = targetDate.getTime() - Date.now();
      setTimeLeft(diff);

      if (diff <= 0) {
        clearInterval(interval);

        if (onComplete) {
          onComplete();
        }
      }
    };

    updateTimer();
    interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [targetDate, onComplete]);

  if (timeLeft <= 0) {
    return 'Expired';
  }

  const totalSeconds = Math.floor(timeLeft / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const totalHours = Math.floor(totalSeconds / 3600);

  const days = Math.floor(totalSeconds / (24 * 60 * 60));
  const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  let display = '';

  if (totalHours >= 24) {
    display = hours > 0
      ? `${days}d ${hours}h`
      : `${days}d ${minutes}m`;
  } else if (totalHours >= 1) {
    display = `${hours}h ${minutes}m`;
  } else if (totalMinutes >= 1) {
    display = `${minutes}m ${seconds}s`;
  } else {
    display = `${seconds}s`;
  }

  return display;
};
